export default __webpack_public_path__ + "static/media/Kacee.2a7ad31d.png";